import { makeStyles } from "components/mui-core";
import { motion } from "framer-motion";
import React from "react";

const useStyles = makeStyles<{ leftOffset?: number }>()(
  (_theme, { leftOffset }) => ({
    root: {
      marginTop: "45px",
      position: "fixed",
      left: `calc(50% + ${(leftOffset || 0) / 2}px)`,
      transform: "translate(-50%, 0)",
      backgroundColor: "rgb(255, 244, 229)",
      color: "rgb(102, 60, 0)",
      whiteSpace: "nowrap",
      textAlign: "center",
      paddingTop: "15px",
      paddingBottom: "15px",
      borderRadius: "5px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      zIndex: 900,
      height: "50px",
    },
    marginText: {
      marginInline: "30px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
  })
);

interface Props {
  children: React.ReactNode;
  delay?: number;
  leftOffset?: number;
}

export const FloatingNotification = ({
  children,
  delay = 0,
  leftOffset = 0,
}: Props) => {
  // TODO: Add custom type (warning, error, etc) and positions (center-top, bottom-right, etc)
  const { classes: styles } = useStyles({ leftOffset });

  return (
    <motion.div
      className={styles.root}
      initial={{ width: 0 }}
      animate={{
        width: "max(40vw, 700px)",
      }}
      transition={{
        width: {
          type: "spring",
          stiffness: 500,
          damping: 20,
          duration: 3,
          delay,
        },
      }}>
      <motion.span
        className={styles.marginText}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ opacity: { duration: 0.5, delay } }}>
        {children}
      </motion.span>
    </motion.div>
  );
};
